<script setup lang="ts">
const { dispatch } = useStore();

//#region get powerbi access token
const is_access_token_fetched = ref(false);
getPowerBiAccessToken();

async function getPowerBiAccessToken() {
   await dispatch('powerBi/getAccessToken');
   is_access_token_fetched.value = true;
}
//#endregion
</script>
<template>
   <div class="dashboard-index">
      <RouterView v-if="is_access_token_fetched" />
   </div>
</template>

<style lang="scss" scoped>
.dashboard-index {
   width: 100%;
   height: 100%;
}
</style>
